import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocaleService } from '../services/locale/locale.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationInitService {
  constructor(
    private translate: TranslateService,
    private localeService: LocaleService
  ) {}

  async initializeTranslations(): Promise<void> {
    const currentLocale =
      localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE;

    try {
      console.log('Initializing translations for locale:', currentLocale);

      // Set the default language
      this.translate.setDefaultLang(currentLocale);

      // Load translations for the current locale
      await firstValueFrom(this.translate.use(currentLocale));

      console.log(
        'Translations initialized successfully for locale:',
        currentLocale
      );
    } catch (error) {
      console.error('Failed to initialize translations:', error);
      // Continue with app initialization even if translations fail
    }
  }
}
